import { UntypedFormGroup } from '@angular/forms';
import { FormName } from '@core/data-access/models/form/form.model';
import { InputBase } from '@shared/forms/inputs/input-base.class';

export type StepNames = StepName[];

export enum StepName {
  Tickets = 'tickets',
  BuyerInformation = 'buyerInformation',
  BuyerQuestionnaire = 'buyerQuestionnaire',
  TicketAssignment = 'ticketAssignment',
  Legitimation = 'legitimation',
  Workshop = 'workshop',
  Menu = 'menu',
  Confirmation = 'confirmation',
  Recipe = 'recipe',
  Payment = 'payment',
  Invoice = 'invoice',
  TicketDownload = 'ticketDownload'
}

export type StepsFormsActionName = readonly [StepName, FormName?];

export interface InputsListModel {
  rerender: boolean;
  list: InputBase<any>[];
  updatedInputs?: string[];
}

export interface StepModel {
  [key: string]: {
    forms?: null | {
      [key: string]: InputsListModel;
    };
  };
}

export interface OneStepModel {
  forms?: null | {
    [key: string]: InputsListModel;
  };
}

export type StepValidities = Partial<Record<StepName, StepValidity>>;

export interface StepValidity {
  valid: boolean;
  disabled: boolean;
  order: number;
  visible: boolean;
  showInStepNavigation: boolean;
  forms?: StepValidityForms;
}

export type StepValidityForms = null | Partial<Record<FormName, boolean>>;

export interface OrderedStepValidity {
  key: string;
  name: StepName;
  value: StepValidity;
}

export type OrderedStepValidities = OrderedStepValidity[];

export interface FormInputsPayloadModel {
  formInfo: StepsFormsActionName;
  inputSet: InputsListModel;
  callback?: (inputList: InputBase<any>[], rerender: boolean) => void;
  holderUuid?: string;
  /*
   index is used for dynamic forms,
   where we don't know how many forms of a kind are there (for instance ticket holder)
   By index we can later distinguish which Form belongs to which ticket holder
   */
}

export interface FormStatusPayloadModel {
  formInfo: StepsFormsActionName;
  valid: boolean;
}

export interface SetStepFormsValidity {
  stepName: string;
  formValidities: FormValidities;
}

export type FormValidities = Record<FormName, boolean>;

export interface VisibilityPayloadModel {
  stepKey: string;
  visible: boolean;
}

export interface FormGroupValidationModel {
  formActionName: StepsFormsActionName;
  form: UntypedFormGroup;
}

export interface PersonalizationValidationModel {
  ticketHolderInputSets: FormInputsPayloadModel[];
  ticketHoldersFormsValidity: boolean[];
}

export interface Errors {
  code: string;
  message: string;
  values: string[];
}
